module.exports = __webpack_public_path__ + "static/media/1ton-variant-1.405ad40d.jpg";